import request from '@/utils/request'

const basePath = '/api/exam/backup'


/**
 * 获取列表
 * @param params
 * @returns {*}
 */
export function getList(params) {
    return request({
        url: `${basePath}`,
        method: 'GET',
        params: params
    })
}

/**
 * 获取列表
 * @param params
 * @returns {*}
 */
export function getSummary() {
    return request({
        url: `${basePath}/summary`,
        method: 'GET'
    })
}


/**
 * 归档
 * @param params
 * @returns {*}
 */
export function putBackup(params) {
    return request({
        url: `${basePath}/backup`,
        method: 'PUT',
        params: params
    })
}

/**
 * 删除
 * @param params
 * @returns {*}
 */
export function del(params) {
    return request({
        url: `${basePath}`,
        method: 'DELETE',
        params: params
    })
}
